import { Component } from '@angular/core';
import { HeaderLogoResponse, HeaderService } from '../header/header.service';

@Component({
	selector: 'vcm-app-header',
	template: require('./header.component.html')
})

export class HeaderComponent {
	logoUrl: string;

	constructor(
		private headerService: HeaderService
	) {
		this.headerService.getLogo().then((res: HeaderLogoResponse) => {
			this.logoUrl = res.LogoURL;
		});
	}
}
